import firebase from "firebase";

// Initialize Firebase
const config = {

  databaseURL: "https://cardiometabolica-siegfried.firebaseio.com",
  apiKey: "AIzaSyDz6-Kd91tANwHOFWIJivOLdLYpHOuxwPo",
  authDomain: "cardiometabolica-siegfried.firebaseapp.com",
  projectId: "cardiometabolica-siegfried",
  storageBucket: "cardiometabolica-siegfried.appspot.com",
  messagingSenderId: "1082681622491",
  appId: "1:1082681622491:web:96621c0a087f54194ab1fe",
  measurementId: "G-D5BB5TKS38"
};
firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
